/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drone_VideoInputs */

const en_drone_video = /** @type {(inputs: Drone_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drone / Property Video`)
};

const id_drone_video = /** @type {(inputs: Drone_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Drone / Properti`)
};

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const es_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const fr_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const de_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const ja_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const zh_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const ar_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const it_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const ru_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const pt_drone_video = en_drone_video;

/** @type {(inputs: Drone_VideoInputs) => LocalizedString} */
const ko_drone_video = en_drone_video;

/**
* | output |
* | --- |
* | "Drone / Property Video" |
*
* @param {Drone_VideoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const drone_video = /** @type {((inputs?: Drone_VideoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drone_VideoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drone_video(inputs)
	if (locale === "es") return es_drone_video(inputs)
	if (locale === "fr") return fr_drone_video(inputs)
	if (locale === "de") return de_drone_video(inputs)
	if (locale === "ja") return ja_drone_video(inputs)
	if (locale === "zh") return zh_drone_video(inputs)
	if (locale === "ar") return ar_drone_video(inputs)
	if (locale === "id") return id_drone_video(inputs)
	if (locale === "it") return it_drone_video(inputs)
	if (locale === "ru") return ru_drone_video(inputs)
	if (locale === "pt") return pt_drone_video(inputs)
	return ko_drone_video(inputs)
});